import React from 'react';
import style from './acmiFlightStartEndDates.module.scss';
import { DateType } from 'acscp/api/models/customTypes/dateType';
import { Leg } from 'acscp/store';
import {FormattedDate} from '../common/formattedDate';
import {FormattedDateRange} from 'acscp/components/common/formattedDateRange';
import planeImage from 'acscp/assets/plane.svg';

export class AcmiFlightStartEndDates extends React.Component<{legs: Leg[]}, {}> {
    render(): JSX.Element|null {
        const firstLeg = this.props.legs[0];
        const isDateTypeExact = this.props.legs[0].departureDateType === DateType.EXACT;
        return (
            <div className={style.Dates}>
                <span className={style.Date}>
                    <FormattedDateRange date={firstLeg.departureDate} rangeEndDate={firstLeg.departureRangeEndDate}/>
                </span>
                {isDateTypeExact && (
                    <>
                        <span className={style.Date}>
                            <img src={planeImage} className={style.Plane} alt={'Plane Image'}/>
                        </span>
                        <span className={style.Date}>
                            <FormattedDate date={firstLeg.arrivalDate}/>
                        </span>
                    </>
                )}
            </div>
        );
    }
}
